import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { PatientModality } from '../../models/patient-details.model';

@Component({
  selector: 'app-patient-modalities',
  templateUrl: './patient-modalities.component.html',
  styleUrls: ['./patient-modalities.component.scss'],
  standalone: false
})
export class PatientModalitiesComponent implements OnInit, OnChanges {
  @Input() modalities: PatientModality[] = [];

  activeModalities: PatientModality[] = [];

  ngOnInit(): void {
    this.filterActiveModalities();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['modalities']) {
      this.filterActiveModalities();
    }
  }

  private filterActiveModalities(): void {
    if (this.modalities && Array.isArray(this.modalities)) {
      this.activeModalities = this.modalities;
    } else {
      this.activeModalities = [];
    }
  }
}